var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{ref:"elUpload",staticStyle:{"display":"none"},attrs:{"action":"","limit":1,"accept":_vm.accept,"show-file-list":false,"http-request":_vm.handleHttpRequest}},[_c('i',{ref:"upload"})])
}
var staticRenderFns = []

export { render, staticRenderFns }